import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { HiringResourcesHttpClient } from './hiring-resources.http-client';
import { HiringResourcesActions } from './hiring-resources.store';

@Injectable({ providedIn: 'root' })
export class HiringResourcesEffects {
  private readonly httpApi = inject(HiringResourcesHttpClient);
  private readonly actions$ = inject(Actions);

  public effects = createEffectFactory(HiringResourcesActions, this.actions$);

  public fetch = this.effects(
    HiringResourcesActions.fetchCollection,
    ({ payload }) => {
      switch (payload.scope) {
        case 'jobs':
          return this.httpApi.fetchJobs(payload.appGuid).pipe(map(resp => ({ data: resp.data })));
        case 'talentPools':
          return this.httpApi
            .fetchTalentPools(payload.appGuid)
            .pipe(map(resp => ({ data: resp.data })));
        default:
          return of({ data: [] });
      }
    },
    {
      customMapOperator: mergeMap,
    },
  );
}
